import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';
import { HomeComponent } from './pages/home/home.component';
import { HomeTwoComponent } from './pages/home-two/home-two.component';
import { AboutComponent } from './pages/about/about.component';
import { ServicesComponent } from './pages/services/services.component';
import { CourseComponent } from './pages/course/course.component';
import { CourseDetailsComponent } from './pages/course-details/course-details.component';
import { InstructorComponent } from './pages/instructor/instructor.component';
import { InstructorDetailsComponent } from './pages/instructor-details/instructor-details.component';
import { PricingComponent } from './pages/pricing/pricing.component';
import { FaqComponent } from './pages/faq/faq.component';
import { BlogComponent } from './pages/blog/blog.component';
import { BlogSingleComponent } from './pages/blog-single/blog-single.component';
import { ContactComponent } from './pages/contact/contact.component';
import { ThankYouComponent } from './pages/thank-you/thank-you.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { ProductCopierCanonComponent } from './pages/product-copier-canon/product-copier-canon.component';
import { ProductCopierXeroxComponent } from './pages/product-copier-xerox/product-copier-xerox.component';
import { UnderconstructionComponent } from './pages/underconstruction/underconstruction.component';
import { MaintenanceToggleComponent } from './pages/maintenance-toggle/maintenance-toggle.component';
import { HeaderComponent } from './shared/header/header.component';
import { FooterComponent } from './shared/footer/footer.component';
import { MaintenanceModeGuard } from './shared/maintenance-mode.guard';

const routes: Routes = [
  { path: 'under3Construe8tra', component: MaintenanceToggleComponent },
  { path: 'underconstruction', component: UnderconstructionComponent },
  { path: 'under-construction', redirectTo: 'underconstruction', pathMatch: 'full' },

  { path: '', component: HomeComponent, canActivate: [MaintenanceModeGuard] },
  { path: 'home', redirectTo: '', pathMatch: 'full' },
  { path: 'about', component: AboutComponent, canActivate: [MaintenanceModeGuard] },
  { path: 'services', component: ServicesComponent, canActivate: [MaintenanceModeGuard] },
  { path: 'contact', component: ContactComponent, canActivate: [MaintenanceModeGuard] },

  { path: 'product/copier/canon', component: ProductCopierCanonComponent, canActivate: [MaintenanceModeGuard] },
  { path: 'product/copier/canon/:slug', component: ProductCopierCanonComponent, canActivate: [MaintenanceModeGuard] },
  { path: 'product/copier/xerox', component: ProductCopierXeroxComponent, canActivate: [MaintenanceModeGuard] },
  { path: 'product/copier/xerox/:slug', component: ProductCopierXeroxComponent, canActivate: [MaintenanceModeGuard] },
  { path: '404', component: NotFoundComponent, canActivate: [MaintenanceModeGuard] },
  { path: '404.html', redirectTo: '404', pathMatch: 'full' },
  { path: '**', redirectTo: '404' }
];

// { path: 'contact.html', redirectTo: 'contact', pathMatch: 'full' },
// { path: 'thank-you', component: ThankYouComponent },
// { path: 'thank-you.html', redirectTo: 'thank-you', pathMatch: 'full' },
// { path: 'index.html', redirectTo: '', pathMatch: 'full' },
// { path: 'home-2', component: HomeTwoComponent },
// { path: 'home-two', redirectTo: 'home-2', pathMatch: 'full' },
// { path: 'index2', redirectTo: 'home-2', pathMatch: 'full' },
// { path: 'index2.html', redirectTo: 'home-2', pathMatch: 'full' },
// { path: 'about.html', redirectTo: 'about', pathMatch: 'full' },
// { path: 'course', component: CourseComponent },
// { path: 'course.html', redirectTo: 'course', pathMatch: 'full' },
// { path: 'course-details', component: CourseDetailsComponent },
// { path: 'course_details', redirectTo: 'course-details', pathMatch: 'full' },
// { path: 'course_details.html', redirectTo: 'course-details', pathMatch: 'full' },
// { path: 'instructor', component: InstructorComponent },
// { path: 'instructor.html', redirectTo: 'instructor', pathMatch: 'full' },
// { path: 'instructor-details', component: InstructorDetailsComponent },
// { path: 'ins_details', redirectTo: 'instructor-details', pathMatch: 'full' },
// { path: 'ins_details.html', redirectTo: 'instructor-details', pathMatch: 'full' },
// { path: 'pricing', component: PricingComponent },
// { path: 'pricing.html', redirectTo: 'pricing', pathMatch: 'full' },
// { path: 'faq', component: FaqComponent },
// { path: 'faq.html', redirectTo: 'faq', pathMatch: 'full' },
// { path: 'blog', component: BlogComponent },
// { path: 'blog.html', redirectTo: 'blog', pathMatch: 'full' },
// { path: 'blog-single', component: BlogSingleComponent },
// { path: 'blog_single', redirectTo: 'blog-single', pathMatch: 'full' },
// { path: 'blog_single.html', redirectTo: 'blog-single', pathMatch: 'full' },
// { path: 'single_blog', redirectTo: 'blog-single', pathMatch: 'full' },
// { path: 'single_blog.html', redirectTo: 'blog-single', pathMatch: 'full' },

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HomeTwoComponent,
    AboutComponent,
    ServicesComponent,
    CourseComponent,
    CourseDetailsComponent,
    InstructorComponent,
    InstructorDetailsComponent,
    PricingComponent,
    FaqComponent,
    BlogComponent,
    BlogSingleComponent,
    ContactComponent,
    ThankYouComponent,
    NotFoundComponent,
    ProductCopierCanonComponent,
    ProductCopierXeroxComponent,
    UnderconstructionComponent,
    MaintenanceToggleComponent,
    HeaderComponent,
    FooterComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
